<template>
  <vx-modal :title="$t('messages.detail.title')" :active.sync="show" sizeModal="con-vs-popup-mid">
    <vs-table stripe v-if="routine[0].uuid" :data="routine">
      <template>
        <vs-tr>
          <vs-td
            ><strong> {{ $t('routines_templates.detail.name') }} </strong></vs-td
          >
          <vs-td>
            {{ routine[0].name }}
          </vs-td>
        </vs-tr>
        <vs-tr>
          <vs-td
            ><strong> {{ $t('routines_templates.detail.description') }} </strong></vs-td
          >
          <vs-td>
            {{ routine[0].description }}
          </vs-td>
        </vs-tr>
        <vs-tr>
          <vs-td
            ><strong> {{ $t('routines_templates.detail.category') }} </strong></vs-td
          >
          <vs-td>
            {{ routine[0].category.name }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div class="vx-col w-full" v-if="weeks.length > 0">
      <vs-tabs alignment="fixed">
        <template v-for="(week, weekIndex) in weeks">
          <vs-tab :label="`Semana ${week.number}`" :key="weekIndex">
            <vs-tabs alignment="fixed">
              <template v-for="(day, dayIndex) in week.days">
                <vs-tab
                  :label="`Día ${day.number}`"
                  :key="dayIndex"
                  style="overflow: visible"
                >
                <vs-card>
                  <vs-row class="justify-content-between py-1">
                    <vs-col
                      vs-lg="6"
                      vs-md="6"
                      vs-sm="12"
                      vs-xs="12"
                      class="d-flex align-items-start"
                    >
                      <h4>Tipo de trabajo</h4>
                    </vs-col>
                    <vs-col
                      vs-lg="6"
                      vs-md="6"
                      vs-sm="12"
                      vs-xs="12"
                      class="d-flex align-items-start"
                    >
                      <p class="text-lg">{{ day.type_work ? day.type_work : 'Descanso' }}</p>
                    </vs-col>
                  </vs-row>
                </vs-card>
                <vs-card>
                  <vs-row class="justify-content-between py-5 align-items-center">
                    <vs-col
                      vs-lg="4"
                      vs-sm="12"
                      vs-xs="12"
                      class="d-flex align-items-center"
                    >
                      <h2 class="pt-3">
                        Calentamiento
                      </h2>
                    </vs-col>
                    <vs-divider></vs-divider>
                  </vs-row>

                  <vs-row
                    vs-justify="center"
                    vs-w="12"
                    v-for="(compound, compoundIndex) in day.compounds"
                    :key="compoundIndex"
                    class="relative"
                  >
                    <vs-col v-if="compound.stage == 'Calentamiento'">
                      <h5 class="d-flex align-items-center justify-content-between mb-3 sm:w-12/12">
                        <span>{{
                          getNameCompound(compound.category_compound_id)
                        }}</span>
                      </h5>
                      <template v-if="compound.category_compound_id == 4">
                          <vs-row>
                          <vs-col vs-lg="12" class="text-center">
                            {{
                              compound.workouts[0].name ? compound.workouts[0].name : alpha[compoundIndex] + (workoutIndex + 1)
                            }}
                          </vs-col>
                          <vs-col
                            v-if="compound.category_compound_id != 7"
                            vs-lg="12"
                            vs-sm="12"
                            vs-xs="12"
                            class="pr-2"
                          >
                          <vx-select
                              :model.sync="compound.workouts[0].workout_id"
                              :label="
                                $t('routines_templates.labels.workout')
                              "
                              :options="workouts"
                              :translate="false"
                              :uuid="false"
                              :placeholder="'Ejecicio'"
                              class="w-full"
                              disabled
                            ></vx-select>
                          </vs-col>

                          <vs-col
                            v-if="compound.category_compound_id != 7 && compound.category_compound_id != 5"
                            vs-lg="2"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <div class="vx-row">
                              <vs-input 
                              :label="$t('routines_templates.labels.series')"
                              disabled v-model="compound.workouts[0].series" 
                              class="w-full"/>
                            </div>
                          </vs-col>
                          <vs-col
                            v-for="(workout,
                            workoutIndex) in compound.workouts"
                            :key="workoutIndex"
                            vs-lg="3"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.reps')
                                "
                                class="w-full"
                                v-model="workout.repetitions"
                              />
                            </div>
                          </vs-col>
                          <vs-col
                            v-if="compound.category_compound_id != 7"
                            vs-lg="3"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.rest')
                                "
                                class="w-full"
                                v-model="compound.workouts[0].rest"
                              />
                            </div>
                          </vs-col>

                          <vs-col
                            vs-lg="3"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.tempo')
                                "
                                name="tempo"
                                class="w-full"
                                v-model="compound.workouts[0].tempo"
                              />
                            </div>
                          </vs-col>
                          <vs-col
                            v-if="compound.category_compound_id != 7"
                            vs-lg="3"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <vs-input disabled
                              :label="
                                $t('routines_templates.labels.timer')
                              "
                              name="timer"
                              class="w-full"
                              v-model="compound.workouts[0].timer"
                            />
                          </vs-col>
                          <vs-col
                            vs-lg="6"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-1 py-3"
                          >
                          {{$t('routines_templates.labels.note')}}
                            <vs-textarea disabled
                              name="note"
                              rows="2"
                              class="w-full"
                              v-model="compound.workouts[0].note"
                            />
                          </vs-col>
                          <vs-col
                            vs-lg="6"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-1 py-3"
                            v-if="compound.category_compound_id != 7 && compound.category_compound_id != 5"
                          >
                          {{$t('routines_templates.labels.overload')}}
                            <vs-textarea disabled
                              name="note"
                              rows="2"
                              class="w-full"
                              v-model="compound.workouts[0].overload"
                            />
                          </vs-col>
                          </vs-row>
                      </template>
                      <template v-if="compound.category_compound_id == 5">
                        <vs-row>
                          <vs-col vs-lg="12" class="text-center">
                            {{
                              compound.workouts[0].name ? compound.workouts[0].name : alpha[compoundIndex] + (workoutIndex + 1)
                            }}
                          </vs-col>
                          <vs-col
                            vs-lg="3"
                            vs-md="6"
                            vs-sm="12"
                            vs-xs="12"
                            class="px-6"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.preparing_time')
                                "
                                class="w-full"
                                :value="hhmmss(compound.workouts[0].preparing_time)"
                              />
                            </div>
                          </vs-col>
                          <vs-col
                            vs-lg="3"
                            vs-md="6"
                            vs-sm="12"
                            vs-xs="12"
                            class="px-6"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.cycles')
                                "
                                class="w-full"
                                :value="compound.workouts.length"
                              />
                            </div>
                          </vs-col>
                          <vs-col
                            vs-lg="3"
                            vs-md="6"
                            vs-sm="12"
                            vs-xs="12"
                            class="px-6"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.series')
                                "
                                class="w-full"
                                :value="compound.workouts[0].series"
                              />
                            </div>
                          </vs-col>
                          <vs-col
                            vs-lg="3"
                            vs-md="6"
                            vs-sm="12"
                            vs-xs="12"
                            class="px-6"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.rest')
                                "
                                class="w-full"
                                :value="hhmmss(compound.workouts[0].rest)"
                              />
                            </div>
                          </vs-col>
                          <template v-for="(workout,
                                    workoutIndex) in compound.workouts">
                            <div :key="workoutIndex" class="vs-row vs-lg-12">
                              <vs-col
                                vs-lg="6"
                                vs-sm="12"
                                vs-xs="12"
                                class="p-2"
                              >
                                <vx-select
                                    :model.sync="workout.workout_id"
                                    :label="
                                      $t('routines_templates.labels.workout')
                                    "
                                    :options="workouts"
                                    :translate="false"
                                    :uuid="false"
                                    :placeholder="'Ejercicio'"
                                    class="w-full"
                                    disabled
                                ></vx-select>
                              </vs-col>
                              <vs-col
                                vs-lg="6"
                                vs-sm="12"
                                vs-xs="12"
                                class="p-2"
                              >
                                <vs-input disabled
                                  :label="
                                    $t('routines_templates.labels.chronometer')
                                  "
                                  class="w-full"
                                  :value="hhmmss(compound.workouts[0].timer) + ' seg.'"
                                />
                              </vs-col>
                              <vs-divider></vs-divider>
                            </div>
                          </template>
                        </vs-row>
                      </template>
                      <template v-else-if="compound.category_compound_id !== 4 && compound.category_compound_id !== 5">
                        <vs-row
                          vs-justify="center"
                          vs-w="12"
                          v-for="(workout,
                          workoutIndex) in compound.workouts"
                          :key="workoutIndex"
                          class="relative"
                        >
                                <vs-col vs-lg="12" class="text-center">
                                  {{
                                    workout.name ? workout.name : alpha[compoundIndex] + (workoutIndex + 1)
                                  }}
                                </vs-col>
                          <vs-col
                            v-if="compound.category_compound_id != 7"
                            vs-lg="12"
                            vs-sm="12"
                            vs-xs="12"
                            class="pr-2"
                          >
                          <vx-select
                              :model.sync="workout.workout_id"
                              :label="
                                $t('routines_templates.labels.workout')
                              "
                              :options="workouts"
                              :translate="false"
                              :uuid="false"
                              :placeholder="'Ejecicio'"
                              class="w-full"
                              disabled
                            ></vx-select>
                          </vs-col>

                          <vs-col
                            v-if="compound.category_compound_id != 7 && compound.category_compound_id != 5"
                            vs-lg="2"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <div class="vx-row">
                              <vs-input 
                              :label="$t('routines_templates.labels.series')"
                              disabled v-model="workout.series" />
                            </div>
                          </vs-col>
                          <vs-col
                            v-if="compound.category_compound_id != 7 && compound.category_compound_id != 5"
                            vs-lg="3"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.reps')
                                "
                                v-model="workout.repetitions"
                              />
                            </div>
                          </vs-col>
                          <vs-col
                            v-if="compound.category_compound_id != 7"
                            vs-lg="3"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.rest')
                                "
                                v-model="workout.rest"
                              />
                            </div>
                          </vs-col>

                          <vs-col
                            v-if="compound.category_compound_id != 7 && compound.category_compound_id != 5"
                            vs-lg="3"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.tempo')
                                "
                                name="tempo"
                                class="w-full"
                                v-model="workout.tempo"
                              />
                            </div>
                          </vs-col>
                          <vs-col
                            v-if="compound.category_compound_id != 7"
                            vs-lg="3"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <vs-input disabled
                              :label="
                                $t('routines_templates.labels.timer')
                              "
                              name="timer"
                              class="w-full"
                              v-model="workout.timer"
                            />
                          </vs-col>
                          <vs-col
                            vs-lg="6"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-1 py-3"
                          >
                          {{$t('routines_templates.labels.note')}}
                            <vs-textarea disabled
                              name="note"
                              rows="2"
                              class="w-full"
                              v-model="workout.note"
                            />
                          </vs-col>
                          <vs-col
                            vs-lg="6"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-1 py-3"
                            v-if="compound.category_compound_id != 7 && compound.category_compound_id != 5"
                          >
                          {{$t('routines_templates.labels.overload')}}
                            <vs-textarea disabled
                              name="note"
                              rows="2"
                              class="w-full"
                              v-model="workout.overload"
                            />
                          </vs-col>
                          <vs-divider></vs-divider>
                        </vs-row>
                      </template>
                    </vs-col>
                  </vs-row>
                </vs-card>
                <vs-card>
                  <vs-row class="justify-content-between py-5 align-items-center">
                    <vs-col
                      vs-lg="4"
                      vs-sm="12"
                      vs-xs="12"
                      class="d-flex align-items-center"
                    >
                      <h2 class="pt-3">
                        Rutina
                      </h2>
                    </vs-col>
                    <vs-divider></vs-divider>
                  </vs-row>

                  <vs-row
                    vs-justify="center"
                    vs-w="12"
                    v-for="(compound, compoundIndex) in day.compounds"
                    :key="compoundIndex"
                    class="relative"
                  >
                    <vs-col v-if="compound.stage == 'Rutina'">
                      <h5 class="d-flex align-items-center justify-content-between mb-3 sm:w-12/12">
                        <span>{{
                          getNameCompound(compound.category_compound_id)
                        }}</span>
                      </h5>
                      <template v-if="compound.category_compound_id == 4">
                          <vs-row>
                          <vs-col vs-lg="12" class="text-center">
                            {{
                              compound.workouts[0].name ? compound.workouts[0].name : alpha[compoundIndex] + (workoutIndex + 1)
                            }}
                          </vs-col>
                          <vs-col
                            v-if="compound.category_compound_id != 7"
                            vs-lg="12"
                            vs-sm="12"
                            vs-xs="12"
                            class="pr-2"
                          >
                          <vx-select
                              :model.sync="compound.workouts[0].workout_id"
                              :label="
                                $t('routines_templates.labels.workout')
                              "
                              :options="workouts"
                              :translate="false"
                              :uuid="false"
                              :placeholder="'Ejecicio'"
                              class="w-full"
                              disabled
                            ></vx-select>
                          </vs-col>

                          <vs-col
                            v-if="compound.category_compound_id != 7 && compound.category_compound_id != 5"
                            vs-lg="2"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <div class="vx-row">
                              <vs-input 
                              :label="$t('routines_templates.labels.series')"
                              disabled v-model="compound.workouts[0].series" 
                              class="w-full"/>
                            </div>
                          </vs-col>
                          <vs-col
                            v-for="(workout,
                            workoutIndex) in compound.workouts"
                            :key="workoutIndex"
                            vs-lg="3"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.reps')
                                "
                                class="w-full"
                                v-model="workout.repetitions"
                              />
                            </div>
                          </vs-col>
                          <vs-col
                            v-if="compound.category_compound_id != 7"
                            vs-lg="3"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.rest')
                                "
                                class="w-full"
                                v-model="compound.workouts[0].rest"
                              />
                            </div>
                          </vs-col>

                          <vs-col
                            vs-lg="3"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.tempo')
                                "
                                name="tempo"
                                class="w-full"
                                v-model="compound.workouts[0].tempo"
                              />
                            </div>
                          </vs-col>
                          <vs-col
                            v-if="compound.category_compound_id != 7"
                            vs-lg="3"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <vs-input disabled
                              :label="
                                $t('routines_templates.labels.timer')
                              "
                              name="timer"
                              class="w-full"
                              v-model="compound.workouts[0].timer"
                            />
                          </vs-col>
                          <vs-col
                            vs-lg="6"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-1 py-3"
                          >
                          {{$t('routines_templates.labels.note')}}
                            <vs-textarea disabled
                              name="note"
                              rows="2"
                              class="w-full"
                              v-model="compound.workouts[0].note"
                            />
                          </vs-col>
                          <vs-col
                            vs-lg="6"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-1 py-3"
                            v-if="compound.category_compound_id != 7 && compound.category_compound_id != 5"
                          >
                          {{$t('routines_templates.labels.overload')}}
                            <vs-textarea disabled
                              name="note"
                              rows="2"
                              class="w-full"
                              v-model="compound.workouts[0].overload"
                            />
                          </vs-col>
                          </vs-row>
                      </template>
                      <template v-if="compound.category_compound_id == 5">
                        <vs-row>
                          <vs-col vs-lg="12" class="text-center">
                            {{
                              compound.workouts[0].name ? compound.workouts[0].name : alpha[compoundIndex] + (workoutIndex + 1)
                            }}
                          </vs-col>
                          <vs-col
                            vs-lg="3"
                            vs-md="6"
                            vs-sm="12"
                            vs-xs="12"
                            class="px-6"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.preparing_time')
                                "
                                class="w-full"
                                :value="hhmmss(compound.workouts[0].preparing_time)"
                              />
                            </div>
                          </vs-col>
                          <vs-col
                            vs-lg="3"
                            vs-md="6"
                            vs-sm="12"
                            vs-xs="12"
                            class="px-6"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.cycles')
                                "
                                class="w-full"
                                :value="compound.workouts.length"
                              />
                            </div>
                          </vs-col>
                          <vs-col
                            vs-lg="3"
                            vs-md="6"
                            vs-sm="12"
                            vs-xs="12"
                            class="px-6"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.series')
                                "
                                class="w-full"
                                :value="compound.workouts[0].series"
                              />
                            </div>
                          </vs-col>
                          <vs-col
                            vs-lg="3"
                            vs-md="6"
                            vs-sm="12"
                            vs-xs="12"
                            class="px-6"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.rest')
                                "
                                class="w-full"
                                :value="hhmmss(compound.workouts[0].rest)"
                              />
                            </div>
                          </vs-col>
                          <template v-for="(workout,
                                    workoutIndex) in compound.workouts">
                            <div :key="workoutIndex" class="vs-row vs-lg-12">
                              <vs-col
                                vs-lg="6"
                                vs-sm="12"
                                vs-xs="12"
                                class="p-2"
                              >
                                <vx-select
                                    :model.sync="workout.workout_id"
                                    :label="
                                      $t('routines_templates.labels.workout')
                                    "
                                    :options="workouts"
                                    :translate="false"
                                    :uuid="false"
                                    :placeholder="'Ejercicio'"
                                    class="w-full"
                                    disabled
                                ></vx-select>
                              </vs-col>
                              <vs-col
                                vs-lg="6"
                                vs-sm="12"
                                vs-xs="12"
                                class="p-2"
                              >
                                <vs-input disabled
                                  :label="
                                    $t('routines_templates.labels.chronometer')
                                  "
                                  class="w-full"
                                  :value="hhmmss(compound.workouts[0].timer) + ' seg.'"
                                />
                              </vs-col>
                              <vs-divider></vs-divider>
                            </div>
                          </template>
                        </vs-row>
                      </template>
                      <template v-else-if="compound.category_compound_id !== 4 && compound.category_compound_id !== 5">
                        <vs-row
                          vs-justify="center"
                          vs-w="12"
                          v-for="(workout,
                          workoutIndex) in compound.workouts"
                          :key="workoutIndex"
                          class="relative"
                        >
                                <vs-col vs-lg="12" class="text-center">
                                  {{
                                    workout.name ? workout.name : alpha[compoundIndex] + (workoutIndex + 1)
                                  }}
                                </vs-col>
                          <vs-col
                            v-if="compound.category_compound_id != 7"
                            vs-lg="12"
                            vs-sm="12"
                            vs-xs="12"
                            class="pr-2"
                          >
                          <vx-select
                              :model.sync="workout.workout_id"
                              :label="
                                $t('routines_templates.labels.workout')
                              "
                              :options="workouts"
                              :translate="false"
                              :uuid="false"
                              :placeholder="'Ejecicio'"
                              class="w-full"
                              disabled
                            ></vx-select>
                          </vs-col>

                          <vs-col
                            v-if="compound.category_compound_id != 7 && compound.category_compound_id != 5"
                            vs-lg="2"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <div class="vx-row">
                              <vs-input 
                              :label="$t('routines_templates.labels.series')"
                              disabled v-model="workout.series" />
                            </div>
                          </vs-col>
                          <vs-col
                            v-if="compound.category_compound_id != 7 && compound.category_compound_id != 5"
                            vs-lg="3"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.reps')
                                "
                                v-model="workout.repetitions"
                              />
                            </div>
                          </vs-col>
                          <vs-col
                            v-if="compound.category_compound_id != 7"
                            vs-lg="3"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.rest')
                                "
                                v-model="workout.rest"
                              />
                            </div>
                          </vs-col>

                          <vs-col
                            v-if="compound.category_compound_id != 7 && compound.category_compound_id != 5"
                            vs-lg="3"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.tempo')
                                "
                                name="tempo"
                                class="w-full"
                                v-model="workout.tempo"
                              />
                            </div>
                          </vs-col>
                          <vs-col
                            v-if="compound.category_compound_id != 7"
                            vs-lg="3"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <vs-input disabled
                              :label="
                                $t('routines_templates.labels.timer')
                              "
                              name="timer"
                              class="w-full"
                              v-model="workout.timer"
                            />
                          </vs-col>
                          <vs-col
                            vs-lg="6"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-1 py-3"
                          >
                          {{$t('routines_templates.labels.note')}}
                            <vs-textarea disabled
                              name="note"
                              rows="2"
                              class="w-full"
                              v-model="workout.note"
                            />
                          </vs-col>
                          <vs-col
                            vs-lg="6"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-1 py-3"
                            v-if="compound.category_compound_id != 7 && compound.category_compound_id != 5"
                          >
                          {{$t('routines_templates.labels.overload')}}
                            <vs-textarea disabled
                              name="note"
                              rows="2"
                              class="w-full"
                              v-model="workout.overload"
                            />
                          </vs-col>
                          <vs-divider></vs-divider>
                        </vs-row>
                      </template>
                    </vs-col>
                  </vs-row>
                </vs-card>
                <vs-card>
                  <vs-row class="justify-content-between py-5 align-items-center">
                    <vs-col
                      vs-lg="4"
                      vs-sm="12"
                      vs-xs="12"
                      class="d-flex align-items-center"
                    >
                      <h2 class="pt-3">
                        Estiramiento
                      </h2>
                    </vs-col>
                    <vs-divider></vs-divider>
                  </vs-row>

                  <vs-row
                    vs-justify="center"
                    vs-w="12"
                    v-for="(compound, compoundIndex) in day.compounds"
                    :key="compoundIndex"
                    class="relative"
                  >
                    <vs-col v-if="compound.stage == 'Estiramiento'">
                      <h5 class="d-flex align-items-center justify-content-between mb-3 sm:w-12/12">
                        <span>{{
                          getNameCompound(compound.category_compound_id)
                        }}</span>
                      </h5>
                      <template v-if="compound.category_compound_id == 4">
                          <vs-row>
                          <vs-col vs-lg="12" class="text-center">
                            {{
                              compound.workouts[0].name ? compound.workouts[0].name : alpha[compoundIndex] + (workoutIndex + 1)
                            }}
                          </vs-col>
                          <vs-col
                            v-if="compound.category_compound_id != 7"
                            vs-lg="12"
                            vs-sm="12"
                            vs-xs="12"
                            class="pr-2"
                          >
                          <vx-select
                              :model.sync="compound.workouts[0].workout_id"
                              :label="
                                $t('routines_templates.labels.workout')
                              "
                              :options="workouts"
                              :translate="false"
                              :uuid="false"
                              :placeholder="'Ejecicio'"
                              class="w-full"
                              disabled
                            ></vx-select>
                          </vs-col>

                          <vs-col
                            v-if="compound.category_compound_id != 7 && compound.category_compound_id != 5"
                            vs-lg="2"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <div class="vx-row">
                              <vs-input 
                              :label="$t('routines_templates.labels.series')"
                              disabled v-model="compound.workouts[0].series" 
                              class="w-full"/>
                            </div>
                          </vs-col>
                          <vs-col
                            v-for="(workout,
                            workoutIndex) in compound.workouts"
                            :key="workoutIndex"
                            vs-lg="3"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.reps')
                                "
                                class="w-full"
                                v-model="workout.repetitions"
                              />
                            </div>
                          </vs-col>
                          <vs-col
                            v-if="compound.category_compound_id != 7"
                            vs-lg="3"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.rest')
                                "
                                class="w-full"
                                v-model="compound.workouts[0].rest"
                              />
                            </div>
                          </vs-col>

                          <vs-col
                            vs-lg="3"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.tempo')
                                "
                                name="tempo"
                                class="w-full"
                                v-model="compound.workouts[0].tempo"
                              />
                            </div>
                          </vs-col>
                          <vs-col
                            v-if="compound.category_compound_id != 7"
                            vs-lg="3"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <vs-input disabled
                              :label="
                                $t('routines_templates.labels.timer')
                              "
                              name="timer"
                              class="w-full"
                              v-model="compound.workouts[0].timer"
                            />
                          </vs-col>
                          <vs-col
                            vs-lg="6"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-1 py-3"
                          >
                          {{$t('routines_templates.labels.note')}}
                            <vs-textarea disabled
                              name="note"
                              rows="2"
                              class="w-full"
                              v-model="compound.workouts[0].note"
                            />
                          </vs-col>
                          <vs-col
                            vs-lg="6"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-1 py-3"
                            v-if="compound.category_compound_id != 7 && compound.category_compound_id != 5"
                          >
                          {{$t('routines_templates.labels.overload')}}
                            <vs-textarea disabled
                              name="note"
                              rows="2"
                              class="w-full"
                              v-model="compound.workouts[0].overload"
                            />
                          </vs-col>
                          </vs-row>
                      </template>
                      <template v-if="compound.category_compound_id == 5">
                        <vs-row>
                          <vs-col vs-lg="12" class="text-center">
                            {{
                              compound.workouts[0].name ? compound.workouts[0].name : alpha[compoundIndex] + (workoutIndex + 1)
                            }}
                          </vs-col>
                          <vs-col
                            vs-lg="3"
                            vs-md="6"
                            vs-sm="12"
                            vs-xs="12"
                            class="px-6"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.preparing_time')
                                "
                                class="w-full"
                                :value="hhmmss(compound.workouts[0].preparing_time)"
                              />
                            </div>
                          </vs-col>
                          <vs-col
                            vs-lg="3"
                            vs-md="6"
                            vs-sm="12"
                            vs-xs="12"
                            class="px-6"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.cycles')
                                "
                                class="w-full"
                                :value="compound.workouts.length"
                              />
                            </div>
                          </vs-col>
                          <vs-col
                            vs-lg="3"
                            vs-md="6"
                            vs-sm="12"
                            vs-xs="12"
                            class="px-6"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.series')
                                "
                                class="w-full"
                                :value="compound.workouts[0].series"
                              />
                            </div>
                          </vs-col>
                          <vs-col
                            vs-lg="3"
                            vs-md="6"
                            vs-sm="12"
                            vs-xs="12"
                            class="px-6"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.rest')
                                "
                                class="w-full"
                                :value="hhmmss(compound.workouts[0].rest)"
                              />
                            </div>
                          </vs-col>
                          <template v-for="(workout,
                                    workoutIndex) in compound.workouts">
                            <div :key="workoutIndex" class="vs-row vs-lg-12">
                              <vs-col
                                vs-lg="6"
                                vs-sm="12"
                                vs-xs="12"
                                class="p-2"
                              >
                                <vx-select
                                    :model.sync="workout.workout_id"
                                    :label="
                                      $t('routines_templates.labels.workout')
                                    "
                                    :options="workouts"
                                    :translate="false"
                                    :uuid="false"
                                    :placeholder="'Ejercicio'"
                                    class="w-full"
                                    disabled
                                ></vx-select>
                              </vs-col>
                              <vs-col
                                vs-lg="6"
                                vs-sm="12"
                                vs-xs="12"
                                class="p-2"
                              >
                                <vs-input disabled
                                  :label="
                                    $t('routines_templates.labels.chronometer')
                                  "
                                  class="w-full"
                                  :value="hhmmss(compound.workouts[0].timer) + ' seg.'"
                                />
                              </vs-col>
                              <vs-divider></vs-divider>
                            </div>
                          </template>
                        </vs-row>
                      </template>
                      <template v-else-if="compound.category_compound_id !== 4 && compound.category_compound_id !== 5">
                        <vs-row
                          vs-justify="center"
                          vs-w="12"
                          v-for="(workout,
                          workoutIndex) in compound.workouts"
                          :key="workoutIndex"
                          class="relative"
                        >
                                <vs-col vs-lg="12" class="text-center">
                                  {{
                                    workout.name ? workout.name : alpha[compoundIndex] + (workoutIndex + 1)
                                  }}
                                </vs-col>
                          <vs-col
                            v-if="compound.category_compound_id != 7"
                            vs-lg="12"
                            vs-sm="12"
                            vs-xs="12"
                            class="pr-2"
                          >
                          <vx-select
                              :model.sync="workout.workout_id"
                              :label="
                                $t('routines_templates.labels.workout')
                              "
                              :options="workouts"
                              :translate="false"
                              :uuid="false"
                              :placeholder="'Ejecicio'"
                              class="w-full"
                              disabled
                            ></vx-select>
                          </vs-col>

                          <vs-col
                            v-if="compound.category_compound_id != 7 && compound.category_compound_id != 5"
                            vs-lg="2"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <div class="vx-row">
                              <vs-input 
                              :label="$t('routines_templates.labels.series')"
                              disabled v-model="workout.series" />
                            </div>
                          </vs-col>
                          <vs-col
                            v-if="compound.category_compound_id != 7 && compound.category_compound_id != 5"
                            vs-lg="3"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.reps')
                                "
                                v-model="workout.repetitions"
                              />
                            </div>
                          </vs-col>
                          <vs-col
                            v-if="compound.category_compound_id != 7"
                            vs-lg="3"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.rest')
                                "
                                v-model="workout.rest"
                              />
                            </div>
                          </vs-col>

                          <vs-col
                            v-if="compound.category_compound_id != 7 && compound.category_compound_id != 5"
                            vs-lg="3"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <div class="vx-row">
                              <vs-input disabled
                                :label="
                                  $t('routines_templates.labels.tempo')
                                "
                                name="tempo"
                                class="w-full"
                                v-model="workout.tempo"
                              />
                            </div>
                          </vs-col>
                          <vs-col
                            v-if="compound.category_compound_id != 7"
                            vs-lg="3"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-3 mx-2"
                          >
                            <vs-input disabled
                              :label="
                                $t('routines_templates.labels.timer')
                              "
                              name="timer"
                              class="w-full"
                              v-model="workout.timer"
                            />
                          </vs-col>
                          <vs-col
                            vs-lg="6"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-1 py-3"
                          >
                          {{$t('routines_templates.labels.note')}}
                            <vs-textarea disabled
                              name="note"
                              rows="2"
                              class="w-full"
                              v-model="workout.note"
                            />
                          </vs-col>
                          <vs-col
                            vs-lg="6"
                            vs-sm="12"
                            vs-xs="12"
                            class="p-1 py-3"
                            v-if="compound.category_compound_id != 7 && compound.category_compound_id != 5"
                          >
                          {{$t('routines_templates.labels.overload')}}
                            <vs-textarea disabled
                              name="note"
                              rows="2"
                              class="w-full"
                              v-model="workout.overload"
                            />
                          </vs-col>
                          <vs-divider></vs-divider>
                        </vs-row>
                      </template>
                    </vs-col>
                  </vs-row>
                </vs-card>
                </vs-tab>
              </template>
            </vs-tabs>
          </vs-tab>
        </template>
      </vs-tabs>
    </div>
  </vx-modal>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      routine: [
        {
          uuid: null,
          name: null,
          description: null,
          category: {
            name: null
          }
        }
      ],
      show: false,
      day: 0,
      week: 0,
      weeks: [],
      categoriesCompounds: [],
      compound: {
        category_compound_id: 6,
        stage: '',
        workouts: []
      },
      workouts: []
    }
  },
  watch: {
    show(value) {
      if (!value) {
        this.clear()
      }
    },
    week(value) {
      if (value !== null) {
        this.day = 0
      }
    }
  },
  methods: {
    async showModal() {
      this.show = true;
      await this.getCompoundsCategories();
      await this.getWorkouts()
    },
    async getRoutine(uuid) {
      try {
        this.$vs.loading()
        this.weeks = []
        const { data } = await axios.get(
          `${process.env.VUE_APP_API_URL}/api/routines/${uuid}`
        )
        _.forEach(
          data.weeks,
          function (week) {
            const days = [
              {
                number: 1,
                compounds: [],
                type_work: null
              },
              {
                number: 2,
                compounds: [],
                type_work: null
              },
              {
                number: 3,
                compounds: [],
                type_work: null
              },
              {
                number: 4,
                compounds: [],
                type_work: null
              },
              {
                number: 5,
                compounds: [],
                type_work: null
              },
              {
                number: 6,
                compounds: [],
                type_work: null
              },
              {
                number: 7,
                compounds: [],
                type_work: null
              }
            ]
            for (let i = 0; i < week.compounds.length; i++) {
              const index = _.findIndex(days, function (d) {
                // eslint-disable-next-line eqeqeq
                return d.number == week.compounds[i].day.day
              })
              if (index !== -1) {
                days[index].type_work = week.compounds[i].day.type_work
                days[index].compounds.push({
                  ...week.compounds[i].day,
                  workouts: Object.values(week.compounds[i].workouts),
                  category_compound_id: week.compounds[i].category.id,
                  category_compound_name: week.compounds[i].category.name
                })
              }

              for (let j = 0; j < days[index].compounds.length; j++) {
                for (
                  let k = 0;
                  k < days[index].compounds[j].workouts.length;
                  k++
                ) {
                  days[index].compounds[j].workouts[k] = {
                    ...days[index].compounds[j].workouts[k],
                    ...days[index].compounds[j].workouts[k].workout
                  }
                  delete days[index].compounds[j].workouts[k].workout
                }
              }
            }
            this.weeks.push({
              id: week.id,
              number: week.number,
              days
            })
          }.bind(this)
        )
        console.log(data)
        data.weeks = this.weeks
        this.routine[0] = _.assign(this.routine[0], data)
        this.$vs.loading.close()
      } catch (error) {
        this.$vs.loading.close()
        console.log('Ocurrió un error:', error)
      }
    },
    clear() {
      this.routine[0].uuid = null
      this.routine[0].name = null
      this.routine[0].description = null
      this.routine[0].category.name = null
    },
    getNameCompound(id) {
      const cat = this.categoriesCompounds.filter(cat => cat.id == id)
      if (cat.length > 0) {
        return cat[0].name
      }
    },
    generateWeeks() {
      this.weeks = []
      for (let i = 0; i < 4; i++) {
        this.weeks.push({
          id: null,
          number: i + 1,
          days: [
            {
              number: 1,
              compounds: [],
              type_work: null
            },
            {
              number: 2,
              compounds: [],
              type_work: null
            },
            {
              number: 3,
              compounds: [],
              type_work: null
            },
            {
              number: 4,
              compounds: [],
              type_work: null
            },
            {
              number: 5,
              compounds: [],
              type_work: null
            },
            {
              number: 6,
              compounds: [],
              type_work: null
            },
            {
              number: 7,
              compounds: [],
              type_work: null
            }
          ]
        })
      }
    },
    async getCompoundsCategories() {
      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_API_URL}/api/compounds/category`
        )

        this.categoriesCompounds = data
        // this.categoriesCompounds.unshift(this.none)
      } catch (error) {
        console.log('Ocurrió un error:', error)
      }
    },
    async getWorkouts() {
      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_API_URL}/api/workouts`
        )
        this.workouts = data.data
        // this.workouts.shift();
        // this.workouts.unshift(this.none)
      } catch (error) {
        console.log('Ocurrió un error:', error)
      }
    },
    pad(num) {
      return ("0"+num).slice(-2);
    },
    hhmmss(secs) {
      var minutes = Math.floor(secs / 60);
      secs = secs%60;
      minutes = minutes%60;
      return `${this.pad(minutes)}:${this.pad(secs)}`;
    }
  }
}
</script>
<style lang="scss">
    input[disabled] {
      opacity: 1!important;
      background-color: rgba(211, 211, 211, 0.5);
    }
    textarea[disabled] {
      opacity: 1!important;
      background-color: rgba(211, 211, 211, 0.5);
    }
    .con-ul-tabs{
      overflow-x: auto;
      overflow-y: hidden
    }
</style>